import { useQuery, useMutation } from '@tanstack/react-query';
import { notificacionesRepository } from '../../infrastructure/http/notificaciones.repository';
import { useAuthStore } from '../../state/auth.store';

export const useChangelogActivas = () => {
  const { accessToken, session } = useAuthStore();

  const isEnabled = !!(
    accessToken &&
    session &&
    !session.mustAnswerSurvey &&
    (session.hasFreemiumAccess || session.hasPremiumAccess)
  );

  return useQuery({
    queryKey: ['notificaciones', 'changelog', 'activas', session?.user ?? 'anon'],
    queryFn: () => notificacionesRepository.getChangelogActivas(),
    enabled: isEnabled,
    staleTime: Infinity,
    gcTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 0,
    throwOnError: false,
  });
};

export const useMarcarChangelogVisto = () => {
  return useMutation({
    mutationFn: (changelogId: number) =>
      notificacionesRepository.marcarVisto(changelogId),
    onError: (error) => {
      console.error('[useMarcarChangelogVisto] Error al marcar como visto:', error);
    },
  });
};